export default "__VITE_ASSET__ooiYtNtf__"